import Startsida from './Startsida.vue';
import Franvaro_meny from './Franvaro_meny.vue';
import Franvaro from './Franvaro.vue';
import Forsakringskassan_VAB from './Forsakringskassan_VAB.vue';


export const routes = [
    { path: '', props:false, component:Startsida },
    { path: '/startsida', props: false, name: 'startsida', component: Startsida },
    { path: '/franvaro_meny', props: false, name: 'franvaro_meny', component: Franvaro_meny },
    { path: '/franvaro', props: false, name: 'franvaro', component: Franvaro },
    { path: '/forsakringskassan_VAB', props: false, name: 'forsakringskassan_VAB', component: Forsakringskassan_VAB },

    { path:'*', component:{ template:'<div class="page_not_found"><h1>Sidan hittades inte</h1></div>'} }
  ];


// WEBPACK FOOTER //
// ./src/routes.js